import React from 'react';
import { Row, Col, Card } from 'react-bootstrap';
import { FaRegQuestionCircle } from 'react-icons/fa';

const RecentSuggestedSection = ({ suggested = [], handleSuggestedClick }) => {
  return (
    <div style={{ maxWidth: '700px', margin: '0.5rem auto 0' }}>
      
      <h6
        style={{
          fontSize: '1rem',
          color: '#6c757d',
          fontWeight: 'bold',
          marginBottom: '1rem',
          letterSpacing: '0.08em',
          textAlign: 'left'
        }}
      >
        Suggested Questions
      </h6>

      <Row className="g-3">
        {suggested.map((item, idx) => (
          <Col key={idx} xs={12}>
            <Card
              className="p-3 shadow-sm"
              style={{
                fontSize: '0.9rem',
                cursor: 'pointer',
                borderRadius: 8,
              }}
              onClick={() => handleSuggestedClick(item.query)}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  width: "100%"
                }}
              >
                <span className="fw-semibold">{item.query}</span>

                <FaRegQuestionCircle size={20} color="#5B88FF" />
              </div>
            </Card>
          </Col>
        ))}
      </Row>
    </div>
  );
};

export default RecentSuggestedSection;
